<template>
  <div class="mobile_detail_box"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
  >
    <div class="mobile_detail_header">
      <p>{{detail.title}}</p>
      <dl class="mobile_detail_header_info">
        <dt>
          <img :src="detail.portrait" alt="头像">
          <span>{{detail.user_name}}</span>
        </dt>
        <dd>
          时间：{{detail.add_time}}
        </dd>
      </dl>
    </div>
    <div v-if = "type === 'text'" :class="contentShow ? 'mobile_detail_content mobile_detail_hide' : 'mobile_detail_content mobile_detail_show'" ref="mobileDetailContent" v-html="detail.content"></div>
    <div v-if = "type === 'video'" class="mobile_detail_video">
      <video-view :src-arr="detail.video_path" :bg-img="detail.bg_img_path"></video-view>
    </div>
    <div v-if = "type === 'text' && contentShow" class="mobile_detail_content_btn mobile_detail_content_btn_shadow" @click="open($event)">
      点击阅读全文 <i class="el-icon-arrow-down"></i>
    </div>
    <ol v-if="mesList.length > 0" class="mobile_detail_comment">
      <li v-for="item in mesList" :key="item.id" class="mobile_detail_comment_item">
        <div class="mobile_detail_comment_item_left">
            <img :src="item.portrait" alt="头像">
        </div>
        <div class="mobile_detail_comment_item_right">
          <dl>
            <dt>{{item.user_name}}</dt>
            <dd>{{item.time}}</dd>
          </dl>
          <p class="mobile_detail_comment_text" v-text="item.content"></p>
        </div>
      </li>
    </ol>
    <div v-if = "mesList.length > 0" class="mobile_detail_content_btn" @click="more()">
      更多评论
    </div>
    <listView :list="commenList"></listView>
  </div>
</template>

<script>
import video from '../Public/video.vue'
import list from './listM.vue'
export default {
  components: {
    videoView: video,
    listView: list
  },
  data () {
    return {
      loading: true,
      detail: {},
      type: '',
      mesList: [], // 评论列表
      commenList: [], // 推荐列表
      contentShow: true // 详情内容是否显示
    }
  },
  created () {
    this.getDetail()
  },
  updated () {
    const div = this.$refs.mobileDetailContent.querySelectorAll('div')
    for (let i = 0; i < div.length; i++) {
      div[i].style.marginTop = '0.2rem'
      div[i].style.textIndent = '0.56rem'
      div[i].style.fontSize = '0.25rem'
      div[i].style.lineHeight = '0.30rem'
    }
  },
  methods: {
    // 获取详情信息
    getDetail () {
      const vueThat = this
      vueThat.myApi.totalDetailsMobile({ list_id: vueThat.$route.query.id }).then((res) => {
        if (res.data.code === 200) {
          // 如果video_path为空，显示内容为视频详情，否则为文章详情
          if (res.data.data.data.video_path === '') {
            vueThat.type = 'text'
          } else {
            vueThat.type = 'video'
          }
          vueThat.loading = false
          vueThat.detail = res.data.data.data
          vueThat.mesList = res.data.data.mes_data
          vueThat.myApi.labelRecommendMobile({ list_id: vueThat.detail.list_id }).then((list) => {
            if (list.data.code === 200) {
              vueThat.commenList = list.data.data
            }
          }).catch((res) => {})
        }
      })
    },
    // 展开内容
    open () {
      this.contentShow = false
    },
    // 查看更多评论
    more () {
      // this.$alert('前往APP查看', '', {
      //   confirmButtonText: '确定',
      //   callback: action => {
      //   }
      // })
    }
  }
}

</script>

<style>
</style>
